import { Panel } from '../components/Card';
import { useState } from 'react';
import { Button } from '../components/Button';

const SCREENS = [
  {
    title: 'No check, no checkmate',
    body:
      "Kings can be moved into capture and captured outright. There's no rule that forces you to defend the king — but losing the king ends the game. Some cards swap the loss condition (e.g. Ascendant Royalty: lose your queen, lose the game).",
  },
  {
    title: 'The card draft',
    body:
      'Before each match, you and your opponent each draw 3 unique cards from a shared deck of 27. Pick one. The picked rule is active for your side for the whole game.',
  },
  {
    title: 'Both rules are visible',
    body:
      "Your card and your opponent's are both shown on the side panel from move 1. Asymmetric rules are part of the game; plan around them.",
  },
  {
    title: 'Bug or idea? Send it',
    body:
      'Use Support the Site to send bugs and card ideas. If a card interaction feels off, include the game id when you have one.',
  },
];

export function HelpRoute() {
  const [i, setI] = useState(0);
  const max = SCREENS.length;
  const screen = SCREENS[i]!;
  return (
    <div className="h-full w-full max-w-[900px] mx-auto px-5 md:px-10 py-6 grid grid-rows-[auto_1fr] gap-5">
      <div>
        <h1 className="font-display text-3xl font-bold">Guide</h1>
        <p className="text-sm text-ink-muted">Four screens. About sixty seconds.</p>
      </div>
      <Panel className="p-8 flex flex-col">
        <div className="flex gap-1.5 mb-6" aria-label="Progress">
          {SCREENS.map((_, n) => (
            <span
              key={n}
              className={`h-1.5 flex-1 rounded-full transition ${
                n <= i ? 'bg-accent' : 'bg-ink/10'
              }`}
            />
          ))}
        </div>
        <div className="flex-1 grid place-items-center text-center max-w-prose mx-auto">
          <div>
            <div className="text-xs uppercase tracking-wider text-ink-muted">
              Step {i + 1} of {max}
            </div>
            <h2 className="mt-2 font-display text-3xl font-bold">{screen.title}</h2>
            <p className="mt-4 text-lg text-ink-muted leading-snug">{screen.body}</p>
          </div>
        </div>
        <div className="mt-6 flex justify-between">
          <Button variant="ghost" onClick={() => setI(Math.max(0, i - 1))} disabled={i === 0}>
            Back
          </Button>
          {i < max - 1 ? (
            <Button onClick={() => setI(i + 1)}>Next</Button>
          ) : (
            <Button onClick={() => setI(0)} variant="secondary">
              Start over
            </Button>
          )}
        </div>
      </Panel>
    </div>
  );
}
